import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Text,
  Flex,
  Switch,
  Heading,
  Spinner,
  useToast,
  Input,
} from "@chakra-ui/react";

const UsersHandle = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const toast = useToast();

  const fetchUsers = async () => {
    try {
      const response = await axios.get("https://api.epos.tdrsoftware.in/get/all/users");
      const data = response.data;

      if (Array.isArray(data.users)) {
        setUsers(data.users);
      } else if (Array.isArray(data)) {
        setUsers(data);
      } else {
        toast({
          title: "Unexpected data format from server.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        setUsers([]);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
      toast({
        title: "Error fetching users",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

 const toggleStatus = async (userId) => {
  try {
    await axios.put(`https://api.epos.tdrsoftware.in/update/user/status/${userId}`);
    setUsers((prevUsers) =>
      prevUsers.map((user) =>
        user._id === userId
          ? {
              ...user,
              status: user.status === "active" ? "inactive" : "active",
              isVerified:
                user.status === "inactive" || user.status === undefined
                  ? true
                  : user.isVerified,
            }
          : user
      )
    );
  } catch (error) {
    console.error("Error updating status:", error);
    toast({
      title: "Failed to update status",
      status: "error",
      duration: 3000,
      isClosable: true,
    });
  }
};


  useEffect(() => {
    fetchUsers();
  }, []);

  const filteredUsers = users.filter(
    (user) =>
      user._id.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.userName.toLowerCase().includes(searchTerm.toLowerCase())
  );

const getBorderColor = (user) => {
  if (!user.status) return "yellow.400"; // New user (no status)
  if (user.status === "inactive") return "red.400";
  if (user.status === "active" && !user.isVerified) return "yellow.400"; // First-time activation
  return "green.400"; // Verified and active
};

  if (loading) {
    return (
      <Flex justify="center" align="center" height="100vh">
        <Spinner size="xl" />
      </Flex>
    );
  }

  return (
    <Box p={6}>
      <Heading mb={4}>User Management</Heading>
      <Text mb={2} fontWeight="bold">Search</Text>
      <Input
        placeholder="Search by User ID or Username"
        mb={4}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      {filteredUsers.length === 0 ? (
        <Text>No users match your search.</Text>
      ) : (
        filteredUsers.map((user) => (
          <Flex
            key={user._id}
            justify="space-between"
            align="center"
            p={4}
            borderWidth={2}
            borderRadius="md"
            mb={2}
            borderColor={getBorderColor(user)}
          >
            <Box>
              <Text fontWeight="bold">{user.userName}</Text>
              <Text>Status: {user.status || "new"}</Text>
              <Text fontSize="xs" color="gray.500">
                ID: {user._id}
              </Text>
            </Box>
            <Switch
              colorScheme="teal"
              isChecked={user.status === "active"}
              onChange={() => toggleStatus(user._id)}
            />
          </Flex>
        ))
      )}
    </Box>
  );
};

export default UsersHandle;
